import shopCategories from './shopCategories';

const getSubcategories = categoryTitle => {
  const theCategory = shopCategories.find(
    category => categoryTitle === category.categoryTitle
  );

  if (theCategory) {
    return theCategory.subcategory;
  }

  return [];
};

export default getSubcategories;
